import { COOKIE_VISITOR_ID } from '@marketplace/config/cookie.js'

/* eslint-disable */

// import js-cookie (not sure why yet, but leaving it here for now)
!(function (e) {
    var n
    if (
        // eslint-disable-next-line no-undef
        ('function' == typeof define && define.amd && (define(e), (n = !0)),
        'object' == typeof exports && ((module.exports = e()), (n = !0)),
        !n)
    ) {
        var t = window.Cookies,
            o = (window.Cookies = e())
        o.noConflict = function () {
            return (window.Cookies = t), o
        }
    }
})(function () {
    /**
     *
     */
    function e() {
        for (var e = 0, n = {}; e < arguments.length; e++) {
            var t = arguments[e]
            for (var o in t) n[o] = t[o]
        }
        return n
    }
    /**
     * @param e
     */
    function n(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
    }
    return (function t(o) {
        /**
         *
         */
        function r() {}
        /**
         * @param n
         * @param t
         * @param i
         */
        function i(n, t, i) {
            if ('undefined' != typeof document) {
                'number' == typeof (i = e({ path: '/' }, r.defaults, i)).expires &&
                    (i.expires = new Date(1 * new Date() + 864e5 * i.expires)),
                    (i.expires = i.expires ? i.expires.toUTCString() : '')
                try {
                    var c = JSON.stringify(t)
                    ;/^[\{\[]/.test(c) && (t = c)
                } catch (e) {}
                ;(t = o.write
                    ? o.write(t, n)
                    : encodeURIComponent(String(t)).replace(
                          /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                          decodeURIComponent
                      )),
                    (n = encodeURIComponent(String(n))
                        .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
                        .replace(/[\(\)]/g, escape))
                var f = ''
                for (var u in i)
                    i[u] && ((f += '; ' + u), !0 !== i[u] && (f += '=' + i[u].split(';')[0]))
                return (document.cookie = n + '=' + t + f)
            }
        }
        /**
         * @param e
         * @param t
         */
        function c(e, t) {
            if ('undefined' != typeof document) {
                for (
                    var r = {}, i = document.cookie ? document.cookie.split('; ') : [], c = 0;
                    c < i.length;
                    c++
                ) {
                    var f = i[c].split('='),
                        u = f.slice(1).join('=')
                    t || '"' !== u.charAt(0) || (u = u.slice(1, -1))
                    try {
                        var a = n(f[0])
                        if (((u = (o.read || o)(u, a) || n(u)), t))
                            try {
                                u = JSON.parse(u)
                            } catch (e) {}
                        if (((r[a] = u), e === a)) break
                    } catch (e) {}
                }
                return e ? r[e] : r
            }
        }
        return (
            (r.set = i),
            (r.get = function (e) {
                return c(e, !1)
            }),
            (r.getJSON = function (e) {
                return c(e, !0)
            }),
            (r.remove = function (n, t) {
                i(n, '', e(t, { expires: -1 }))
            }),
            (r.defaults = {}),
            (r.withConverter = t),
            r
        )
    })(function () {})
})
// END import js-cookie
/* eslint-enable */
const Cookies = window.Cookies

export const createSession = (vueReferrer = document.referrer) => {
    return new Promise((resolve) => {
        let sessionMedium = 'not set'
        let sessionWebsite = 'not set'
        let sessionUrl = 'not set'
        let sessionSource = 'not set'
        let sessionCampaign = 'not set'

        const urlSearchParams = new URLSearchParams(window.location.search)
        const referrerURLObject = vueReferrer ? new URL(vueReferrer) : false
        const utmMedium = urlSearchParams.get('utm_medium')
        const utmSource = urlSearchParams.get('utm_source')
        const utmCampaign = urlSearchParams.get('utm_campaign')

        //hostnames
        const email = ['mail.google', 'outlook', 'hotmail', 'drip', 'sendgrid']
        const search = ['google', 'bing', 'duckduckgo']
        const social = ['facebook', 'instagram', 'twitter', 'linkedin']
        const orderchamp = ['www.orderchamp.test', 'www.orderchamp.dev', 'www.orderchamp.com']
        const blog = ['blog.orderchamp.com']

        const isOrderchampReferrer = vueReferrer
            ? orderchamp.some((el) => referrerURLObject.hostname.includes(el))
            : false
        //set sessionMedium
        if (utmMedium && !isOrderchampReferrer) {
            sessionMedium = utmMedium
        } else if (vueReferrer) {
            const isEmailMedium = email.some((el) => referrerURLObject.hostname.includes(el))
            const isSearchMedium = search.some((el) => referrerURLObject.hostname.includes(el))
            const isSocialMedium = social.some((el) => referrerURLObject.hostname.includes(el))
            const isOrderchampMedium = orderchamp.some((el) =>
                referrerURLObject.hostname.includes(el)
            )
            const isBlogMedium = blog.some((el) => referrerURLObject.hostname.includes(el))
            if (isEmailMedium) {
                sessionMedium = 'email other'
            } else if (isSearchMedium) {
                sessionMedium = 'search organic'
            } else if (isSocialMedium) {
                sessionMedium = 'social organic'
            } else if (isBlogMedium) {
                sessionMedium = 'blog'
            } else if (isOrderchampMedium) {
                sessionMedium = 'direct'
            } else {
                sessionMedium = 'referral'
            }
        } else {
            sessionMedium = 'direct'
        }

        //set sessionWebsite and sessionUrl
        if (vueReferrer) {
            if (isOrderchampReferrer) {
                sessionWebsite = 'none'
                sessionUrl = 'none'
            } else {
                sessionWebsite = referrerURLObject.hostname
                sessionUrl = vueReferrer
            }
        } else {
            sessionWebsite = 'none'
            sessionUrl = 'none'
        }

        // set sessionSource
        if (utmSource && !isOrderchampReferrer) {
            sessionSource = utmSource
        } else if (vueReferrer) {
            if (isOrderchampReferrer) {
                sessionSource = 'direct'
            } else {
                sessionSource = referrerURLObject.hostname.replace('www.', '')
            }
        } else {
            sessionSource = 'direct'
        }

        //set sessionCampaign
        if (utmCampaign) {
            sessionCampaign = utmCampaign
        }

        // define existing and new session
        let existingSession = null
        if (
            Cookies.get('oc_session_medium') &&
            Cookies.get('oc_session_website') &&
            Cookies.get('oc_session_url') &&
            Cookies.get('oc_session_source') &&
            Cookies.get('oc_session_campaign')
        ) {
            existingSession = {
                sessionMedium: Cookies.get('oc_session_medium'),
                sessionWebsite: Cookies.get('oc_session_website'),
                sessionUrl: Cookies.get('oc_session_url'),
                sessionCampaign: Cookies.get('oc_session_campaign'),
                sessionSource: Cookies.get('oc_session_source'),
            }
        }
        let newSession = {
            sessionMedium,
            sessionWebsite,
            sessionUrl,
            sessionCampaign,
            sessionSource,
        }

        //set expiry date of cookie
        const midnight = new Date(new Date().setHours(24, 0, 0, 0))

        // choose the updated session based on some conditions
        let updatedSession
        if (existingSession) {
            // there is an existing session
            const hasChanged =
                existingSession.sessionMedium !== newSession.sessionMedium ||
                existingSession.sessionWebsite !== newSession.sessionWebsite ||
                existingSession.sessionUrl !== newSession.sessionUrl ||
                existingSession.sessionCampaign !== newSession.sessionCampaign ||
                existingSession.sessionSource !== newSession.sessionSource
            const isDirect =
                newSession.sessionMedium === 'direct' || newSession.sessionSource === 'direct'
            if (hasChanged) {
                if (isDirect) {
                    updatedSession = existingSession
                } else {
                    // overwrite cookie when referrer is not orderchamp, with new sessionsourcedata
                    updatedSession = newSession
                }
            } else {
                // cookie hasn'changed in existing session
                updatedSession = existingSession
            }
        } else {
            // there is no existing session
            updatedSession = newSession
        }

        Cookies.set('oc_session_medium', updatedSession.sessionMedium, {
            expires: midnight,
            sameSite: 'strict',
        })
        Cookies.set('oc_session_website', updatedSession.sessionWebsite, {
            expires: midnight,
            sameSite: 'strict',
        })
        Cookies.set('oc_session_url', updatedSession.sessionUrl, {
            expires: midnight,
            sameSite: 'strict',
        })
        Cookies.set('oc_session_campaign', updatedSession.sessionCampaign, {
            expires: midnight,
            sameSite: 'strict',
        })
        Cookies.set('oc_session_source', updatedSession.sessionSource, {
            expires: midnight,
            sameSite: 'strict',
        })
        Cookies.set('screen_height', window.screen ? window.screen.height : null, {
            expires: midnight,
            sameSite: 'strict',
        })
        Cookies.set('screen_width', window.screen ? window.screen.width : null, {
            expires: midnight,
            sameSite: 'strict',
        })

        window.getOCSessionData().then(() => {
            resolve()
        })
    })
}

window.getOCSessionData = () => {
    return new Promise(function (resolve) {
        window.OCSessionData = {
            sessionMedium: Cookies.get('oc_session_medium'),
            sessionWebsite: Cookies.get('oc_session_website'),
            sessionUrl: Cookies.get('oc_session_url'),
            sessionCampaign: Cookies.get('oc_session_campaign'),
            sessionSource: Cookies.get('oc_session_source'),
            screenWidth: window.screen ? window.screen.width : 'unknown',
            screenHeight: window.screen ? window.screen.height : 'unknown',
            eventDate: new Date().toISOString(),
            realUserId: window.Store?.userId || '',
            accountId: window.Store?.accountId || '',
            visitorCookieId: Cookies.get(COOKIE_VISITOR_ID) || 'systemUser',
            experimentGroup: window.Store?.experimentGroup,
            orderchampPlusPlan: window.Store?.orderchampPlusPlan,
            country_code: window.Store?.country || '',
            state: window.Store.accountType ? 'logged-in' : 'logged-out',
        }
        resolve()
    })
}

export const sessionStart = async (vueReferrer) => {
    const result = await createSession(vueReferrer)
    return result
}

const triggerLoggedOutPageView = () => {
    window.analytics.ready(function () {
        // WARNING if you make a change in this part you have to copy it over to pageview.js
        // segment brings the FB and GA tags, so you need to wait till segment is ready to start tracking FA/GA
        if (window.fbq) {
            window.fbq('track', 'PageView')
        }
    })
}

/**
 * Get the current path with query params similar to the old twig functionality.
 *
 * @returns {string}
 */
function getOClocalelessPath() {
    const pathWithQuery = window.location.pathname + window.location.search
    const capturingRegex = /\/(?<locale>nl|de|fr|pl|da|it|es)(\/|$)/i

    return pathWithQuery.replace(capturingRegex, '/')
}

const triggerIdentifyAndPageView = (customReferrer, internalReferrer) => {
    let OClocalelessPath = window.OClocalelessPath || getOClocalelessPath()

    const pageParams = {
        name: OClocalelessPath.toLowerCase(),
        path: OClocalelessPath.toLowerCase(),
        locale: window.Store.locale,
        type: window.Store.accountType?.toLowerCase(),
        custom_referrer: customReferrer,
        internal_referrer: internalReferrer,
        recommended: window.Store?.accountId ? 'no' : null,
        state: window.Store.accountId ? 'logged-in' : ' logged-out',
        ...(window.checkoutPageViewParams && { ...window.checkoutPageViewParams }),
        ...window.OCSessionData,
    }

    const identifyParams = {
        id: window.Store.accountId,
        name: window.Store.accountName,
        createdAt: window.Store.accountCreatedAt,
        type: window.Store.accountType,
        locale: window.Store.locale,
        ...window.OCSessionData,
    }

    if (window.OCexperimentId?.length && window.OCexperimentVariant?.length) {
        pageParams.experiment_id = window.OCexperimentId
        pageParams.variation_id = window.OCexperimentVariant
        pageParams.experimentId = window.OCexperimentId
        pageParams.variationId = window.OCexperimentVariant
    }

    window.analytics.identify(identifyParams.id, {
        ...identifyParams,
    })
    setTimeout(() => {
        window.analytics.page(pageParams.name, pageParams)
    }, 100)
}

/**
 *
 */
window.triggerPageView = function triggerPageView() {
    if (!window.OCshouldSendToAnalytics) return false
    if (window.Store.isExcludedFromTracking) return false

    const referrer = document.referrer
    const orderchampWebsites = ['www.orderchamp.test', 'www.orderchamp.dev', 'www.orderchamp.com']
    const isOrderchampReferrer = orderchampWebsites.some((el) => referrer.includes(el))
    let customReferrer = ''
    let internalReferrer = ''
    if (referrer) {
        if (isOrderchampReferrer) {
            const url = new URL(referrer)
            const localePathnameRgx = /^\/[a-z]{2}\// //matches the referrers pathname, i.e. /nl/, /de/ etc.
            const localeLessPathname = url.pathname.replace(localePathnameRgx, '/')
            customReferrer = new URL(localeLessPathname, referrer).toString()
            internalReferrer = url.pathname.replace(localePathnameRgx, '/')
        } else {
            customReferrer = referrer
        }
    }

    sessionStart().then(() => {
        triggerIdentifyAndPageView(customReferrer, internalReferrer)
    })
}
/**
 *
 */
function init() {
    if (!window.OCsessionStart) {
        window.OCsessionStart = sessionStart
    }

    window.analytics.ready(function () {
        window.triggerPageView()
    })

    if (!window.Store.accountId) {
        if (window.OCshouldSendToAnalytics) {
            triggerLoggedOutPageView()
            sessionStart()
        }
    }
}

if (globalThis.hasDelayedTracking) {
    window.addEventListener('client:initialized', () => {
        init()
    })
} else {
    init()
}
